import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
  static values = {
    defaultPlaceholder: { type: String, default: "Select an option" },
    selectText: { type: String, default: "Press to select" },
    sort: { type: Boolean, default: true },
  };

  connect() {
    const hasBlankOption = Array.from(
      this.element.querySelectorAll("option"),
    ).some((option) => option.value === "");

    const options = {
      allowHTML: true,
      itemSelectText: this.selectTextValue,
      shouldSort: this.sortValue,

      // If blank option present, allow it to be selected by enabling the remove item button
      removeItemButton: hasBlankOption,
    };

    // Set default placeholder unless select contains a blank option
    if (!hasBlankOption) {
      options.placeholderValue = this.defaultPlaceholderValue;
    }

    this.choicesInstance = new Choices(this.element, options);
  }
}
